(() => {
  const labels = {
    pricing: 'Pricing & quotation',
    materials: 'Materials & approval',
    design: 'Design & technical',
    lighting: 'Lighting & electrical',
    production: 'Production',
    delivery: 'Delivery',
    aftercare: 'Changes & aftercare',
    professionals: 'Files & trade'
  };

  const initSection = (section) => {
    if (!section || section.dataset.guidedFaqReady === 'true') return;

    const buttons = Array.from(section.querySelectorAll('[data-faq-topic]'));
    const items = Array.from(section.querySelectorAll('[data-faq-item]'));
    const activeLabel = section.querySelector('[data-faq-active-label]');
    if (!buttons.length || !items.length) return;

    const availableTopics = new Set(items.map((item) => item.dataset.faqTopic).filter(Boolean));

    buttons.forEach((button) => {
      if (!availableTopics.has(button.dataset.faqTopic)) {
        button.hidden = true;
      }
    });

    const setTopic = (topic, focus = false) => {
      if (!availableTopics.has(topic)) {
        topic = Array.from(availableTopics)[0];
      }
      if (!topic) return;

      buttons.forEach((button) => {
        const isActive = button.dataset.faqTopic === topic;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive && focus) button.focus({ preventScroll: true });
      });

      items.forEach((item) => {
        const show = item.dataset.faqTopic === topic;
        if (!show && item.open) item.removeAttribute('open');
        item.hidden = !show;
      });

      if (activeLabel) activeLabel.textContent = labels[topic] || topic;
      section.dataset.activeTopic = topic;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => setTopic(button.dataset.faqTopic));
    });

    const requested = section.dataset.defaultTopic;
    const initial = availableTopics.has(requested) ? requested : Array.from(availableTopics)[0];
    setTopic(initial);
    section.dataset.guidedFaqReady = 'true';
  };

  const initAll = (root = document) => {
    root.querySelectorAll?.('[data-oylin-guided-faq]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();